import { useMediaQuery, useTheme } from '@material-ui/core';

/** Below the theme's sm breakpoint; read on the first render so a dialog never flashes in its desktop form. */
export const usePhoneLayout = (): boolean => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
};
